import { createFileRoute, useParams } from '@tanstack/react-router';

import { CatalogDetail } from '@/features/dictionary/components/catalog-detail';

export const Route = createFileRoute('/app/dictionary/$alias')({
  component: DictionaryDetailRoute,
});

function DictionaryDetailRoute() {
  const { alias } = useParams({ from: '/app/dictionary/$alias' });
  return <CatalogDetail alias={alias} />;
}
